import { render, staticRenderFns } from "./ViewProgressDetails.vue?vue&type=template&id=40f149a9&scoped=true"
import script from "./ViewProgressDetails.vue?vue&type=script&lang=js"
export * from "./ViewProgressDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewProgressDetails.vue?vue&type=style&index=0&id=40f149a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f149a9",
  null
  
)

export default component.exports